import { AxiosProcessor } from "../../shared/axios/AxiosProcessor"

const APPROVAL_PATH = '/approval';

const state = {
  approvals: {},
  documentApprovals: {},
  reportApprovals: {},
  documentLastEvaluatedKey: {},
  reportLastEvaluatedKey: {}
};

const mutations = {
  SET_APPROVAL: (state, approval) => {
    if (approval.type === 'DOCUMENT') {
      state.documentApprovals[approval.id] = { ...state.approvals[approval.id], ...approval};
    } else if (approval.type === 'REPORT') {
      state.reportApprovals[approval.id] = { ...state.approvals[approval.id], ...approval};
    }
  },
  SET_DOCUMENT_APPROVALS: (state, approvals) => {
    state.documentApprovals = approvals;
  },
  SET_REPORT_APPROVALS: (state, approvals) => {
    state.reportApprovals = approvals;
  },
  SET_APPROVALS_DETAILS: (state, approvalDetails) => {
    state.approvalDetails = approvalDetails;
  },
  SET_DOCUMENT_LAST_EVALUATED_KEY: (state, data) => {
    state.documentLastEvaluatedKey = data;
  },
  SET_REPORT_LAST_EVALUATED_KEY: (state, data) => {
    state.reportLastEvaluatedKey = data;
  }
};

const actions = {

  async getDocumentApprovals({ commit }, data) {
    let url = `${APPROVAL_PATH}?type=DOCUMENT`;

    if (data.limit) {
      url = `${url}&limit=${data.limit}`;
    }

    if (data.status !== 'none') {
      url = `${url}&status=${data.status}`;
    }

    if (data.lastEvaluatedKey) {
      url = `${url}&lastEvaluatedKey=${encodeURIComponent(JSON.stringify(data.lastEvaluatedKey))}`
    }
    const response = await AxiosProcessor.get(url);
    response.Items ? commit('SET_DOCUMENT_APPROVALS', response.Items.reduce((acc, obj) => (acc[obj.id] = obj, acc), {})) : commit('SET_DOCUMENT_APPROVALS', {});
    response.LastEvaluatedKey ? commit('SET_DOCUMENT_LAST_EVALUATED_KEY', response.LastEvaluatedKey) : null;
  },

  async getReportApprovals({ commit }, data) {
    let url = `${APPROVAL_PATH}?type=REPORT`;

    if (data.limit) {
      url = `${url}&limit=${data.limit}`
    }

    if (data.status !== 'none') {
      url = `${url}&status=${data.status}`;
    }

    if (data.lastEvaluatedKey) {
      url = `${url}&lastEvaluatedKey=${encodeURIComponent(JSON.stringify(data.lastEvaluatedKey))}`
    }

    const response = await AxiosProcessor.get(url);
    response.Items ? commit('SET_REPORT_APPROVALS', response.Items.reduce((acc, obj) => (acc[obj.id] = obj, acc), {})) : commit('SET_REPORT_APPROVALS', {});
    response.LastEvaluatedKey ? commit('SET_REPORT_LAST_EVALUATED_KEY', response.LastEvaluatedKey) : null;
  },

  async setApproval({ commit }, data) {
    if (data.id) {
      await AxiosProcessor.put(APPROVAL_PATH + '/' + data.id, data);
    } else {
      await AxiosProcessor.post(APPROVAL_PATH, data);
    }

    commit('SET_APPROVAL', data);
  }
};

const getters = {
  getDocumentApprovals: state => Object.values(state.documentApprovals),
  getReportApprovals: state => Object.values(state.reportApprovals),
  getDocumentApprovalsLastEvaluatedKey: state => state.documentLastEvaluatedKey,
  getReportApprovalsLastEvaluatedKey: state => state.reportLastEvaluatedKey
};

export default {
  state,
  getters,
  mutations,
  actions
}
